var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EBDFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.875C11.393 4.875 9.82214 5.35152 8.486 6.24431C7.14985 7.1371 6.10844 8.40605 5.49348 9.8907C4.87852 11.3753 4.71762 13.009 5.03112 14.5851C5.34463 16.1612 6.11846 17.6089 7.25476 18.7452C8.39106 19.8815 9.8388 20.6554 11.4149 20.9689C12.991 21.2824 14.6247 21.1215 16.1093 20.5065C17.594 19.8916 18.8629 18.8502 19.7557 17.514C20.6485 16.1779 21.125 14.607 21.125 13C21.1209 10.8464 20.2635 8.78216 18.7407 7.25932C17.2178 5.73648 15.1536 4.87913 13 4.875ZM17.375 13.625H13C12.8342 13.625 12.6753 13.5592 12.5581 13.4419C12.4409 13.3247 12.375 13.1658 12.375 13V8.625C12.375 8.45924 12.4409 8.30027 12.5581 8.18306C12.6753 8.06585 12.8342 8 13 8C13.1658 8 13.3247 8.06585 13.4419 8.18306C13.5592 8.30027 13.625 8.45924 13.625 8.625V12.375H17.375C17.5408 12.375 17.6997 12.4408 17.8169 12.5581C17.9342 12.6753 18 12.8342 18 13C18 13.1658 17.9342 13.3247 17.8169 13.4419C17.6997 13.5592 17.5408 13.625 17.375 13.625Z",
    fill: "#6000E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ba3a420dd8349145671265c1684e84cd.svg";
export { ForwardRef as ReactComponent };